export default __webpack_public_path__ + "static/media/nixy.b0a416f1.jpeg";